import Image from "next/image";

export const ComponentFooterLogo = () => {
    return (
        <Image src={"/images/footer-logo.svg"} width={69} height={66} alt={""} />
    )
}